import { c as _c } from "react/compiler-runtime";
import Img from '@/components/elements/Img';
import { LANGUAGES, LOCALE } from '@/constants/config';
import useActivityBookingAvailableDates from '@/contexts/activityBookingContext/hooks/useActivityBookingAvailableDates';
import useActivityBookingAvailableExtras from '@/contexts/activityBookingContext/hooks/useActivityBookingAvailableExtras';
import useActivityBookingAvailableLanguages from '@/contexts/activityBookingContext/hooks/useActivityBookingAvailableLanguages';
import useActivityBookingAvailableTariffs from '@/contexts/activityBookingContext/hooks/useActivityBookingAvailableTariffs';
import useActivityBookingAvailableTimes from '@/contexts/activityBookingContext/hooks/useActivityBookingAvailableTimes';
import useActivityBookingStock from '@/contexts/activityBookingContext/hooks/useActivityBookingStock';
import useActivityBookingTabs from '@/contexts/activityBookingContext/hooks/useActivityBookingTabs';
import useActivityBookingTotalPersons from '@/contexts/activityBookingContext/hooks/useActivityBookingTotalPersons';
import useIsDev from '@/contexts/appContext/hooks/useIsDev';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import usePageFormErrors from '@/contexts/pageContext/hooks/usePageFormErrors';
import useActiveBreakpoints from '@/contexts/tailwindContext/hooks/useActiveBreakpoints';
import { FFormIdEnum } from '@/types/form';
import { ExtrasFormAccordion, LanguageFormAccordion, PersonsFormAccordion, SingleDateFormAccordion, TimeFormAccordion } from '@winelidays/wld-tsx-2/modules';
import { LFormStepKeyEnum } from '@winelidays/wld-tsx-2/types';
const ActivityBookingForm = () => {
    const $ = _c(74);
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    const isDev = useIsDev();
    const { md } = useActiveBreakpoints();
    const { showFormErrors, setShowFormErrors } = usePageFormErrors(FFormIdEnum.BOOKING);
    const tabs = useActivityBookingTabs();
    const { setFetchLanguages, availableLanguages, loadingAvailableLanguages, availableLanguagesQueryError } = useActivityBookingAvailableLanguages();
    const { setDateRange, loadingAvailableDates, availableDates, availableDatesQueryError } = useActivityBookingAvailableDates();
    const { setFetchTimes, availableTimes, loadingAvailableTimes, availableTimesQueryError } = useActivityBookingAvailableTimes();
    const stock = useActivityBookingStock();
    const availableTariffs = useActivityBookingAvailableTariffs();
    const availableExtras = useActivityBookingAvailableExtras();
    const totalPersons = useActivityBookingTotalPersons();
    let t0;
    if ($[0] !== tabs) {
        t0 = tabs.find(_temp);
        $[0] = tabs;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const personsTab = t0;
    let t1;
    if ($[2] !== tabs) {
        t1 = tabs.find(_temp2);
        $[2] = tabs;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const languageTab = t1;
    let t2;
    if ($[4] !== tabs) {
        t2 = tabs.find(_temp3);
        $[4] = tabs;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const dateTab = t2;
    let t3;
    if ($[6] !== tabs) {
        t3 = tabs.find(_temp4);
        $[6] = tabs;
        $[7] = t3;
    }
    else {
        t3 = $[7];
    }
    const timeTab = t3;
    let t4;
    if ($[8] !== tabs) {
        t4 = tabs.find(_temp5);
        $[8] = tabs;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    const extrasTab = t4;
    let t5;
    if ($[10] !== tabs) {
        t5 = (i) => {
            tabs.slice(0, i).forEach(_temp6);
        };
        $[10] = tabs;
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    const handleCompletePreviousTabs = t5;
    let t6;
    if ($[12] !== availableExtras || $[13] !== currencySymbol || $[14] !== extrasTab || $[15] !== handleCompletePreviousTabs || $[16] !== setShowFormErrors || $[17] !== showFormErrors || $[18] !== timeTab || $[19] !== totalPersons || $[20] !== translate) {
        t6 = availableExtras.length > 0 && extrasTab ?
            <ExtrasFormAccordion isPreviousTabCompleted={timeTab.isCompleted} tab={extrasTab} handleCompletePreviousTabs={handleCompletePreviousTabs} isLast={true} translate={translate} showFormErrors={showFormErrors} setShowFormErrors={setShowFormErrors} formId={FFormIdEnum.BOOKING} forceAccordionOpen={false} availableExtras={availableExtras} personsCount={totalPersons} currencySymbol={currencySymbol}/> : null;
        $[12] = availableExtras;
        $[13] = currencySymbol;
        $[14] = extrasTab;
        $[15] = handleCompletePreviousTabs;
        $[16] = setShowFormErrors;
        $[17] = showFormErrors;
        $[18] = timeTab;
        $[19] = totalPersons;
        $[20] = translate;
        $[21] = t6;
    }
    else {
        t6 = $[21];
    }
    const extrasBookingForm = t6;
    let t7;
    if ($[22] !== availableTariffs || $[23] !== handleCompletePreviousTabs || $[24] !== personsTab || $[25] !== setShowFormErrors || $[26] !== showFormErrors || $[27] !== stock || $[28] !== translate) {
        t7 = <PersonsFormAccordion isPreviousTabCompleted={true} tab={personsTab} handleCompletePreviousTabs={handleCompletePreviousTabs} stock={stock} translate={translate} showFormErrors={showFormErrors} setShowFormErrors={setShowFormErrors} formId={FFormIdEnum.BOOKING} forceAccordionOpen={false} availableTariffs={availableTariffs}/>;
        $[22] = availableTariffs;
        $[23] = handleCompletePreviousTabs;
        $[24] = personsTab;
        $[25] = setShowFormErrors;
        $[26] = showFormErrors;
        $[27] = stock;
        $[28] = translate;
        $[29] = t7;
    }
    else {
        t7 = $[29];
    }
    let t8;
    if ($[30] !== availableLanguages || $[31] !== availableLanguagesQueryError || $[32] !== handleCompletePreviousTabs || $[33] !== isDev || $[34] !== languageTab || $[35] !== loadingAvailableLanguages || $[36] !== personsTab.isCompleted || $[37] !== setFetchLanguages || $[38] !== setShowFormErrors || $[39] !== showFormErrors || $[40] !== translate) {
        t8 = <LanguageFormAccordion isPreviousTabCompleted={personsTab.isCompleted} tab={languageTab} handleCompletePreviousTabs={handleCompletePreviousTabs} setFetchLanguages={setFetchLanguages} availableLanguages={availableLanguages} loadingAvailableLanguages={loadingAvailableLanguages} availableLanguagesQueryError={availableLanguagesQueryError} translate={translate} showFormErrors={showFormErrors} setShowFormErrors={setShowFormErrors} formId={FFormIdEnum.BOOKING} forceAccordionOpen={false} locale={LOCALE} languages={LANGUAGES} isDev={isDev} imgComponent={Img} whiteMarking={true}/>;
        $[30] = availableLanguages;
        $[31] = availableLanguagesQueryError;
        $[32] = handleCompletePreviousTabs;
        $[33] = isDev;
        $[34] = languageTab;
        $[35] = loadingAvailableLanguages;
        $[36] = personsTab.isCompleted;
        $[37] = setFetchLanguages;
        $[38] = setShowFormErrors;
        $[39] = showFormErrors;
        $[40] = translate;
        $[41] = t8;
    }
    else {
        t8 = $[41];
    }
    let t9;
    if ($[42] !== availableDates || $[43] !== availableDatesQueryError || $[44] !== dateTab || $[45] !== handleCompletePreviousTabs || $[46] !== isDev || $[47] !== languageTab.isCompleted || $[48] !== loadingAvailableDates || $[49] !== md || $[50] !== setDateRange || $[51] !== setShowFormErrors || $[52] !== showFormErrors || $[53] !== translate) {
        t9 = <SingleDateFormAccordion isPreviousTabCompleted={languageTab.isCompleted} tab={dateTab} handleCompletePreviousTabs={handleCompletePreviousTabs} availableDates={availableDates} loadingAvailableDates={loadingAvailableDates} availableDatesQueryError={availableDatesQueryError} setDateRange={setDateRange} translate={translate} showFormErrors={showFormErrors} setShowFormErrors={setShowFormErrors} formId={FFormIdEnum.BOOKING} locale={LOCALE} isDev={isDev} md={md} isClient={true} forceAccordionOpen={false} whiteMarking={true}/>;
        $[42] = availableDates;
        $[43] = availableDatesQueryError;
        $[44] = dateTab;
        $[45] = handleCompletePreviousTabs;
        $[46] = isDev;
        $[47] = languageTab.isCompleted;
        $[48] = loadingAvailableDates;
        $[49] = md;
        $[50] = setDateRange;
        $[51] = setShowFormErrors;
        $[52] = showFormErrors;
        $[53] = translate;
        $[54] = t9;
    }
    else {
        t9 = $[54];
    }
    const t10 = availableTimesQueryError;
    const t11 = !extrasBookingForm;
    let t12;
    if ($[55] !== availableTimes || $[56] !== dateTab.isCompleted || $[57] !== handleCompletePreviousTabs || $[58] !== isDev || $[59] !== loadingAvailableTimes || $[60] !== setFetchTimes || $[61] !== setShowFormErrors || $[62] !== showFormErrors || $[63] !== t10 || $[64] !== t11 || $[65] !== timeTab || $[66] !== translate) {
        t12 = <TimeFormAccordion isPreviousTabCompleted={dateTab.isCompleted} tab={timeTab} handleCompletePreviousTabs={handleCompletePreviousTabs} setFetchTimes={setFetchTimes} availableTimes={availableTimes} loadingAvailableTimes={loadingAvailableTimes} availableTimesQueryError={t10} isLast={t11} translate={translate} showFormErrors={showFormErrors} setShowFormErrors={setShowFormErrors} formId={FFormIdEnum.BOOKING} isDev={isDev} isClient={true} forceAccordionOpen={false} whiteMarking={true}/>;
        $[55] = availableTimes;
        $[56] = dateTab.isCompleted;
        $[57] = handleCompletePreviousTabs;
        $[58] = isDev;
        $[59] = loadingAvailableTimes;
        $[60] = setFetchTimes;
        $[61] = setShowFormErrors;
        $[62] = showFormErrors;
        $[63] = t10;
        $[64] = t11;
        $[65] = timeTab;
        $[66] = translate;
        $[67] = t12;
    }
    else {
        t12 = $[67];
    }
    let t13;
    if ($[68] !== extrasBookingForm || $[69] !== t12 || $[70] !== t7 || $[71] !== t8 || $[72] !== t9) {
        t13 = <div className="mt-4">{t7}{t8}{t9}{t12}
      {extrasBookingForm}
    </div>;
        $[68] = extrasBookingForm;
        $[69] = t12;
        $[70] = t7;
        $[71] = t8;
        $[72] = t9;
        $[73] = t13;
    }
    else {
        t13 = $[73];
    }
    return t13;
};
export default ActivityBookingForm;
function _temp(t0) { const { _key } = t0; return _key === LFormStepKeyEnum.persons; }
function _temp2(t0) { const { _key: _key_0 } = t0; return _key_0 === LFormStepKeyEnum.language; }
function _temp3(t0) { const { _key: _key_1 } = t0; return _key_1 === LFormStepKeyEnum.date; }
function _temp4(t0) { const { _key: _key_2 } = t0; return _key_2 === LFormStepKeyEnum.time; }
function _temp5(t0) { const { _key: _key_3 } = t0; return _key_3 === LFormStepKeyEnum.extras; }
function _temp6(t) { t.handlers.handleComplete(); }
